import {
  SHOW_ADD_SESSION_FORM,
  UPDATE_SESSION_FIELD,
  CLOSE_ADD_SESSION_FORM,
  UPDATE_SESSION_SUCCEDED,
  DELETE_SESSION_SUCCEDED,
  SHOW_SESSION_ERROR
} from '../actions/sessions'

import {
  SHOW_ADD_EVENT_FORM,
  CLOSE_ADD_EVENT_FORM,
  UPDATE_EVENT_SUCCEDED,
  CHANGE_IMAGE,
  CANCEL_IMAGE,
  RECEIVE_EVENTS_LINKS,
  DELETE_EVENT_SUCCEDED,
  SHOW_ATTENDEES,
  HIDE_ATTENDEES,
  SHOW_PAST_EVENTS,
  UPDATE_EVENT_FIELD,
  UPDATE_EVENTS_FILTER,
  SHOW_NOTIFICATION_FORM,
  UPDATE_NOTIFICATION_FIELD,
  UPDATE_REMINDER_FIELD,
  CLOSE_NOTIFICATION_FORM,
  UPDATE_NOTIFICATIONS_SUCCEDED,
  RECEIVE_EVENTS,
  SHOW_ERROR_EVENTS,
  SHOW_SPINNER,
  CHANGE_PAGE
} from '../actions/events'

import { RECEIVED_COMPANIES } from '../actions/companies'

import { RECEIVED_BUILDINGS, showSpinner } from '../actions/buildings'

import { RECEIVE_USERS, CHECKED_IN, CHECKED_OUT, REGISTERED, UNREGISTERED } from '../actions/users'

const eventsReducer = (state = { filter: { buildingId: ' ', companyId: ' ' } }, action) => {
  var newEvents = []
  var newSessions = []

  switch (action.type) {
    case REGISTERED:
    case UNREGISTERED:
    case CHECKED_IN:
    case CHECKED_OUT:
      newSessions = state.sessions.filter(session => {
        return session._id !== action.session._id
      })

      newSessions.push(action.session)

      newEvents = state.events.map(event => {
        if (event.sessions && event.sessions.length > 0) {
          var sessions = event.sessions
          sessions = sessions.map(sessions => {
            return sessions._id
          })
          if (sessions.indexOf(action.session._id) > -1) {
            return Object.assign({}, event, { sessions: newSessions })
          }
        }
        return event
      })

      return {
        ...state,
        sessions: newSessions,
        events: newEvents
      }

    case SHOW_NOTIFICATION_FORM:
      return {
        ...state,
        notification: action.notification,
        reminder: action.reminder,
        eventInfo: action.eventInfo
      }
    case CLOSE_NOTIFICATION_FORM:
      return {
        ...state,
        notification: null,
        reminder: null,
        eventInfo: null,
        event: null,
        error: null
      }
    case UPDATE_NOTIFICATION_FIELD:
      return {
        ...state,
        notification: { ...state.notification, [action.name]: action.value }
      }
    case UPDATE_REMINDER_FIELD:
      return {
        ...state,
        reminder: { ...state.reminder, [action.name]: action.value }
      }
    case UPDATE_NOTIFICATIONS_SUCCEDED:
      newEvents = state.events.filter(event => {
        return event._id !== action.event._id
      })

      newEvents.push(action.event)

      return {
        ...state,
        notification: null,
        reminder: null,
        events: newEvents,
        event: null,
        error: null
      }
    case UPDATE_EVENTS_FILTER:
      console.log(state.filter)
      return {
        ...state,
        filter: { ...state.filter, [action.filter]: action.value },
        pageOrFilterChanged: true,
        pageNumber: 1
      }
    case SHOW_ERROR_EVENTS:
      return {
        ...state,
        error: action.error
      }
    case SHOW_PAST_EVENTS:
      return {
        ...state,
        showPastEvents: action.showPastEvents,
        pageOrFilterChanged: true,
        pageNumber: 1
      }
    case SHOW_ATTENDEES:
      return {
        ...state,
        sessions: action.sessions
      }
    case HIDE_ATTENDEES:
      return {
        ...state,
        sessions: null
      }
    case CANCEL_IMAGE:
      return {
        ...state,
        event: { ...state.event, newImage: null }
      }
    case CHANGE_IMAGE:
      return {
        ...state,
        event: { ...state.event, newImage: action.image },
        error: null,
        showSpinner: false
      }
    case RECEIVE_EVENTS:
      return {
        ...state,
        eventsFetched: true,
        events: action.json.eventInstances,
        totalEventsAfterFilters: action.json.totalEventsAfterFilters,
        pageOrFilterChanged: false
      }
    case RECEIVE_EVENTS_LINKS:
      return {
        ...state,
        eventsLinksFetched: true,
        eventsLinks: action.json
      }
    case RECEIVED_BUILDINGS:
      return {
        ...state,
        buildingsFetched: true,
        buildings: action.json.buildings
      }
    case RECEIVED_COMPANIES:
      return {
        ...state,
        companiesFetched: true,
        companies: action.json.companies
      }
    case RECEIVE_USERS:
      return {
        ...state,
        usersFetched: true,
        users: action.json.users
      }
    case SHOW_ADD_EVENT_FORM:
      return {
        ...state,
        event: action.event,
        showSpinner: false,
        error: null
      }

    case SHOW_SPINNER:
      return {
        ...state,
        showSpinner: true
      }
    case CLOSE_ADD_EVENT_FORM:
      return {
        ...state,
        event: null,
        error: null,
        showSpinner: false
      }
    case UPDATE_EVENT_FIELD:
      return {
        ...state,
        event: { ...state.event, [action.name]: action.value },
        company: null,
        building: null,
        error: null,
        showSpinner: false
      }

    case UPDATE_EVENT_SUCCEDED:
      newEvents = state.events.filter(event => {
        return event._id !== action.event._id
      })

      newEvents.push(action.event)

      var newEventsLinks = state.eventsLinks
      if (action.event.eventLink) {
        newEventsLinks = state.eventsLinks.filter(event => {
          return event._id !== action.event.eventLink._id
        })
        newEventsLinks.push(action.event.eventLink)
      }

      return {
        ...state,
        event: null,
        events: newEvents,
        eventsLinks: newEventsLinks
      }
    case DELETE_EVENT_SUCCEDED:
      return {
        ...state,
        event: null,
        events: state.events.filter(event => {
          return event._id !== action.event._id
        })
      }
    case SHOW_SESSION_ERROR:
      return {
        ...state,
        sessionError: action.error
      }
    case SHOW_ADD_SESSION_FORM:
      return {
        ...state,
        sessionError: '',
        session: action.session,
        error: null,
        showSpinner: false
      }
    case CLOSE_ADD_SESSION_FORM:
      return {
        ...state,
        sessionError: '',
        session: null,
        error: null
      }
    case UPDATE_SESSION_FIELD:
      return {
        ...state,
        session: { ...state.session, [action.name]: action.value }
      }

    case UPDATE_SESSION_SUCCEDED:
      newSessions = state.event.sessions.filter(session => {
        return session._id !== action.session._id
      })

      var session = action.session
      session.startDateTime = new Date(session.startDateTime)
      session.endDateTime = new Date(session.endDateTime)

      newSessions.push(action.session)

      return {
        ...state,
        session: null,
        event: { ...state.event, sessions: newSessions }
      }
    case DELETE_SESSION_SUCCEDED:
      newSessions = state.event.sessions.filter(session => {
        return session._id !== action.session._id
      })
      return {
        ...state,
        session: null,
        event: { ...state.event, sessions: newSessions }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        pageNumber: action.pageNumber,
        pageOrFilterChanged: true
      }

    default:
      return {
        ...state
      }
  }
}

export default eventsReducer



// WEBPACK FOOTER //
// ./src/reducers/events.js